import { useSetRecoilState } from 'recoil'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { notifyParent, storeGet } from 'mailup-react-helpers'
import { STORE_KEY_ID_LIST } from 'mailup-react-helpers'

import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants'

import { beSendGoCheckSendingProgress } from 'Api/beSendGoApi'
import { campaignsBuilderGetEmailCampaignByIdMessage } from 'Api/campaignsBuilderApi'

import { modalMessageBeingSentState } from 'Recoil/state/modalsState'
import { errorState } from 'Recoil/state/errorState'

import { logAppError } from 'Helpers/logger'

export async function isSendingMessage(idMessage) {
  const { Value } = await beSendGoCheckSendingProgress(idMessage)
  return Value
}

/**
 *
 * @param {number} idMessage
 * @param {boolean} isBee
 * @param {string} messageType

 * @returns {Function} onClick
 */
const useMessageEditAction = (idMessage, isBee, messageType) => {
  const intl = useIntl()
  const history = useHistory()

  const setModal = useSetRecoilState(modalMessageBeingSentState)
  const setError = useSetRecoilState(errorState)

  const onClick = async () => {
    try {
      const isSending = await isSendingMessage(idMessage)

      if (isSending) {
        setModal({ show: true })
      } else {
        if (isBee && messageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
          const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

          const campaign = await campaignsBuilderGetEmailCampaignByIdMessage(
            idMessage,
            idList
          )

          notifyParent('redirectMainFrame', [
            `App.aspx#/beePluginEditor/editCMP/${campaign.Id}`
          ])
        } else if (isBee && messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
          history.push(`/messages/email/bee/edit/${idMessage}`)
        } else {
          notifyParent('redirectMainFrame', [
            `form_upd_newsletter.aspx?source=listemail&idNL=${idMessage}`
          ])
        }
      }
    } catch (error) {
      //  eslint-disable-next-line
      console.error('### error', error)
      logAppError({
        appError: error
      })
      setError(prev => ({
        ...prev,
        error: intl.formatMessage({ id: 'Load.Alerts.ErrorGeneric' })
      }))
    }
  }

  return onClick
}

export default useMessageEditAction
